import { Injectable } from '@angular/core';
import { AlertPayload } from './redux/model';
import { Store } from '@ngrx/store';
import { State } from './redux/reducer';
import { Add, Remove, Clean } from './redux/actions';

@Injectable({
  providedIn: 'root',
})
export class HeaderAlertService {
  constructor(private store: Store<State>) {}

  add(alertData: AlertPayload) {
    this.store.dispatch(new Add({ alert: alertData }));
  }

  remove(ids: number[]) {
    this.store.dispatch(new Remove({ ids: ids }));
  }

  clean() {
    this.store.dispatch(new Clean());
  }
}
